import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import styles from './AnalysisFailedView.module.css';

interface AnalysisFailedViewProps {
  analysisName?: string;
  errorMessage?: string;
}

export const AnalysisFailedView: React.FC<AnalysisFailedViewProps> = ({
  analysisName,
  errorMessage
}) => {
  const navigate = useNavigate();

  return (
    <div className={styles.errorContainer}>
      <i className={`pi pi-exclamation-circle ${styles.errorIcon}`} />
      <h2 className={styles.errorTitle}>Analysis Failed to Process</h2>
      {analysisName && (
        <p className={styles.errorSubtitle}>
          "{analysisName}" could not be completed
        </p>
      )}
      <Message
        severity="error"
        text={
          errorMessage ||
          'An error occurred while processing the analysis. Please try again or contact support.'
        }
        className={styles.errorMessage}
      />
      <div className={styles.buttonContainer}>
        <Button
          label="Back to Analyses"
          icon="pi pi-arrow-left"
          onClick={() => navigate('/analyses')}
          className={styles.backButton}
        />
      </div>
    </div>
  );
};
